// extracted by mini-css-extract-plugin
export default {"wrapper":"i1-z","play":"j1-z"};